import * as React from 'react';
import styled from 'styled-components';
import { __, __r } from 'react-i18n';
import { withRouter, WithRouterProps } from 'react-router';
import { rem } from 'polished';
import { TextP } from '../../../Defaults/Text';
import { Loader } from '../../../Defaults/Loader';
import { ErrorAlert } from '../../../Defaults/Alerts/ErrorAlert';
import { StyledTitle } from '../../ProductDetail/Description';
import { DsiCheckBox } from '../../General/Checkbox';
import { Button } from '../../General/Button';
import { ConfirmDialog, Modal } from '../../../..';

const Wrapper = styled.div`
  width: 100%;
  max-width: ${rem(320)};
  padding: 0;
  border-radius: ${rem(4)};

  ${({ theme }) => theme.mediab.l925`
   padding-top: ${rem(24)};
  `}
`;

interface RemoveAccountBlockPropsIO {
  deleteAccount: any;
}

interface State {
  fetching: boolean;
  isModalOpen: boolean;
}

export class RemoveAccountBlock extends React.Component<
  RemoveAccountBlockPropsIO,
  State
> {
  constructor(props) {
    super(props);
    this.state = { fetching: false, isModalOpen: false };
  }

  public onRemoveAccountButtonClick = () => {
    this.setState({ isModalOpen: true });
  };

  public onCloseModal = () => {
    this.setState({ isModalOpen: false });
  };

  public onConfirmRemove = async () => {
    if (this.props.deleteAccount) {
      this.setState({ fetching: true });
      await this.props.deleteAccount();
      this.setState({ fetching: false });
    }
  };

  public render() {
    const { fetching } = this.state;
    return (
      <Loader loading={fetching}>
        <Wrapper>
          <StyledTitle>{__('Odstránenie účtu')}</StyledTitle>
          <Button onClick={this.onRemoveAccountButtonClick}>
            {' '}
            {__('Zmazať účet')}
          </Button>
        </Wrapper>

        {this.state.isModalOpen ? (
          <ConfirmDialog
            message={__('Naozaj chcete zmazať účet?')}
            onCancel={() => {
              this.onCloseModal();
            }}
            onConfirm={() => {
              this.onConfirmRemove();
            }}
            display={true}
          />
        ) : (
          <></>
        )}
      </Loader>
    );
  }
}
